import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "lib/utils";
import * as React from "react";


const buttonVariants = cva(
  "group/button tw-relative tw-inline-flex tw-shrink-0 hover:tw-no-underline tw-border-none tw-items-center tw-outline-none tw-justify-center tw-gap-x-2 tw-rounded tw-px-10 tw-duration-300 focus-visible:tw-outline-none disabled:tw-cursor-not-allowed disabled:!tw-shadow-none sm:tw-rounded-md",

  {
    variants: {
      variant: {
        accent:
          "tw-bg-accent tw-text-white disabled:tw-bg-accent/[.24] disabled:tw-text-white/80 hover:tw-text-white hover:tw-opacity-80",
          black: "tw-bg-black tw-text-white hover:tw-text-white",
          white: "tw-bg-white tw-text-[#222020] hover:tw-text-white hover:tw-bg-[#222020]"
  
      },
      size: {
        sm: "tw-h-[42px] tw-px-6 tw-text-sm tw-font-medium sm:tw-text-[15px]/[23px] md:tw-h-11",

      },
    
    },
    defaultVariants: {
      variant: "accent",
      size: "sm",
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant = "accent",

      size = "sm",
      asChild = false,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant,  size, className }))}
        ref={ref}
        {...props}
      >
        {props.children}
      </Comp>
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };

